import { Routes } from '@angular/router';
import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';


export const PlacesRoutes: Routes = [
  {
    path: 'places',
    loadComponent: () => import('./pages/places/places.component').then(m => m.PlacesPageComponent),
    title: 'Places | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [PermissionsList[PermissionsList.ClientPlacesView]],
    },
    canActivate: [AuthorizationGuard],
  },
];
